export const BID_ROLE_ENUM = {
  BID_TEAM_MEMBER: 1,
  BID_ADMIN: 2,
  BID_TEAM_ADMIN: 3,
  PRIMARY_ADMIN: 4
};

export const ROLE_OPTIONS = [
  { label: 'Primary Admin', value: BID_ROLE_ENUM.PRIMARY_ADMIN },
  { label: 'Admin', value: BID_ROLE_ENUM.BID_ADMIN },
  { label: 'Team Admin', value: BID_ROLE_ENUM.BID_TEAM_ADMIN },
  { label: 'Team Member', value: BID_ROLE_ENUM.BID_TEAM_MEMBER }
];

export const ROLE_STYLE_MAP = {
  [BID_ROLE_ENUM.PRIMARY_ADMIN]: { bg: '#E5F8FA', text: '#187881', label: 'PRIMARY ADMIN' },
  [BID_ROLE_ENUM.BID_ADMIN]: { bg: '#F0ECF9', text: '#3B2169', label: 'ADMIN' },
  [BID_ROLE_ENUM.BID_TEAM_ADMIN]: { bg: '#FFFAEB', text: '#9E7700', label: 'TEAM ADMIN' },
  [BID_ROLE_ENUM.BID_TEAM_MEMBER]: { bg: '#FDECF2', text: '#950F3C', label: 'MEMBER' }
};

export const STATUS_LOZENGE_MAP = {
  ACTIVE_MEMBER: { color: 'green', variant: 'filled', label: 'ACTIVE MEMBER' },
  PENDING: { color: 'orange', variant: 'filled', label: 'PENDING' }
};

export const MODAL_MODE = {
  ADD: 'add',
  TRANSFER: 'transfer'
};

export const formatLabel = value => String(value).replace(/_/g, ' ');
